
















import { Component, Prop, Vue } from "vue-property-decorator";

import ServiceMenuItem from "@/components/service/ServiceMenuItem.vue";
import { ServiceInterface } from "@/interfaces/service.interface";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";

@Component({
  components: {
    ServiceMenuItem,
  },
})
export default class ServiceItem extends Vue {
  @Prop({ required: true }) private item!: ServiceInterface;

  private onClickServiceMenu(serviceMenu: ServiceMenuInterface): void {
    this.$emit("click-service-menu", serviceMenu);
  }
}
